import { css, mq, spacing, styled } from '@thg-commerce/enterprise-theme'

export const BrandInputWrapper = styled.div<{
  isMobile?: boolean
}>`
  margin-top: ${spacing(2)};

  ${(props) =>
    props.isMobile &&
    `
      margin-top: ${spacing(4)};

      ${mq(props.theme.breakpointUtils.map, 'sm')} {
        margin-top: ${spacing(5)};
       }
       
       @media (orientation: landscape) {
          margin-top: ${spacing(2)};
        }
    `}
`

const containerStyling = css<{
  maxHeight?: string
  isMobile?: boolean
}>`
  ${(props) => props.maxHeight && `max-height: ${props.maxHeight}`};
  overflow-y: auto;

  ${(props) =>
    props.isMobile
      ? `
        margin: ${spacing(4)} 0;

        ${mq(props.theme.breakpointUtils.map, 'sm')} {
          margin: ${spacing(6)} 0;
        }
        
        @media (orientation: landscape) {
           margin: 0;
          }
      `
      : `
        margin: ${spacing(1)} ${spacing(1)} 0 0;

        &::-webkit-scrollbar {
          width: 8px;
        }

        &::-webkit-scrollbar-track {
          background: ${props.theme.colors.palette.greys.lighter};
        }

        &::-webkit-scrollbar-thumb {
          background: ${props.theme.colors.palette.greys.grey};
        }
      `}
`

const itemStyling = css<{
  isMobile?: boolean
  hasBorder?: boolean
}>`
  margin: 0;

  ${(props) =>
    props.hasBorder &&
    `border: 1px solid ${props.theme.colors.palette.greys.grey};
    margin: 0 ${spacing(2)} ${spacing(2)} ${spacing(2)}

    &:hover {
      border: 1px solid ${props.theme.colors.palette.greys.darker}
    }`};

  ${(props) =>
    props.isMobile &&
    `
      border-bottom: 1px solid ${props.theme.colors.palette.greys.light};
      padding-bottom: ${spacing(1)};

      &:not(:first-child) {
        padding-top: ${spacing(1)};
      }
    `}
  }

  &:focus {
  border: 2px solid black;}
`

export const StyledDivContainer = styled.div<{
  maxHeight?: string
  isMobile?: boolean
}>`
  ${containerStyling}
`

export const StyledDivItem = styled.div<{
  isMobile?: boolean
  hasBorder?: boolean
}>`
  ${itemStyling}
`
